<template>
    <b-modal
        data-test-path="dialog-close-unsaved"
        id="bv-modal-close-unsaved"
        @hide="onHide"
        @ok="ok"
        @close="close"

        ref="modal"
    >
      <template v-slot:modal-title>
        {{title}}
      </template>
      <div class="d-block text-center">
        {{message}}
      </div>

      <template #modal-footer="{close}">
        <b-container class="px-0">
          <b-row  class="px-0 justify-content-around no-gutters">
              <FooterButton sm-style="link" button-style="width: unset" class="px-0 col-auto" type="Close"
                            dataTestPath="confirm-close"
                            :label="$tr('dialog.unsaved-dismiss', 'Dismiss & Close')"  @close="closeClicked"></FooterButton>
<!--              <FooterButton sm-style="link" button-style="width: unset" class="px-0 col-auto" :disabled="!canSave" type="Save" label="Save & Close" @save="save">-->
<!--                <template v-slot:icon>-->
<!--                  <font-awesome-layers>-->
<!--                    <font-awesome-icon icon="caret-left" transform="shrink-0 left-7" />-->
<!--                    <font-awesome-icon icon="save" transform="shrink-0 right-5 down-0"  />-->
<!--                  </font-awesome-layers>-->
<!--                </template>-->
<!--              </FooterButton>-->
<!--            variant="plm-link"-->
              <FooterButton  sm-style="link"
                            button-style="width: unset" class="px-0 col-auto" type="Details"
                            :label="$tr('continueEditing','Continue editing')" @details="edit" >
<!--                <template v-slot:icon> <div></div></template>-->
              </FooterButton>

          </b-row>
<!--          <b-row  class="px-0 justify-content-around no-gutters">-->
<!--            or-->
<!--          </b-row>-->
<!--          <b-row  class="px-0 justify-content-around no-gutters">-->
<!--          </b-row>-->
        </b-container>
      </template>

    </b-modal>

</template>

<script>
    import CloseButton from "@/components/navbar/CloseButton";
    import FooterButton from "@/components/navbar/FooterButton";

    export default {
        name: "CloseUnsavedDialog",
      components: {FooterButton, CloseButton},
      async beforeMount() {
        },
        methods: {

          async close(ev){
          },
          async ok(ev){
          },
          async closeClicked(ev){
            if(this.resolve != null){
              this.resolve("close");
              this.resolve = null;
            }
            this.$refs.modal.hide();
          },
          async save(ev){
            if(this.resolve != null){
              this.resolve("save");
              this.resolve = null;
            }
            this.$refs.modal.hide();
          },
          async edit(ev){
            if(this.resolve != null){
              this.resolve("edit");
              this.resolve = null;
            }
            this.$refs.modal.hide();
          },

          async onHide(ev){
              if(this.resolve != null){
                  this.resolve('edit');
                  this.resolve = null;
              }
              this.$refs.modal.hide();
          },

          reset(){
              this.resolve = null;
          }
        },
        data: () => ({
            isYesDanger: false,
            title:"title",
            message:"message",
            resolve: null,
            canSave: true,
            maxLength: 100
        })
    }
</script>
